import * as types from '../actions/action-types';

export function appsByCategory(state = {}, action) {
  switch (action.type) {
    case types.REQUEST_APPS_BY_CATEGORY:
      return {...state, [action.category]: {isFetching: true, items: state[action.category] ? state[action.category].items : []}};

    case types.RECEIVE_APPS_BY_CATEGORY:
      return {...state, [action.category]: {isFetching: false, items: action.items, receivedAt: action.receivedAt, loadedAll: action.loadedAll}};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/apps-by-category.js